export default __webpack_public_path__ + "static/media/15 second header V2.9103a0a8.mp4";